import type { MouseEvent } from 'react'

// A click the app may take over; Cmd/Ctrl/Shift/Alt and the middle button
// stay with the browser (new tab, new window)
export const isPlainLeftClick = (event: MouseEvent): boolean =>
  event.button === 0 &&
  !event.metaKey &&
  !event.ctrlKey &&
  !event.shiftKey &&
  !event.altKey
